import { render, staticRenderFns } from "./WorkInfo.vue?vue&type=template&id=55c4a3fc&"
import script from "./WorkInfo.vue?vue&type=script&lang=js&"
export * from "./WorkInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports